import styled from 'styled-components'

export const Container = styled.div`
  border-bottom: 1px solid ${props => props.theme.palette.general.greyLight};

  h2.cart__heading {
    background: none;
    border-bottom: 1px solid ${props => props.theme.palette.general.greyLight};
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  strong {
    font-weight: bold !important;
  }
`
